import React from "react"
import { Field, Form } from "react-final-form"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { ResetPasswordFormFieldNames } from "./types"
import { useSubmitHandler } from "./useSubmitHandler"
import {
  FormTitle,
  GoBack,
  StyledLoginForm,
  SubmitButton,
  TextField
} from "../../components"
import { FormHeader, Grid } from "../../containers"

export const ResetPasswordForm = ({ executeOnSuccess }) => {
  const { i18n } = useTranslations()
  const { handleSubmit, submitting, error } = useSubmitHandler(executeOnSuccess)

  return <Form onSubmit={handleSubmit}
               render={({ handleSubmit, values }) => <StyledLoginForm
                 onSubmit={handleSubmit}>
                 <Grid>
                   <FormHeader sx={{ marginBottom: "10px" }}>
                     <GoBack/>
                     <FormTitle>{i18n("Account.ForgottenPassword:FormTitle")}</FormTitle>
                   </FormHeader>

                   <Field name={ResetPasswordFormFieldNames.username}>
                     {({ input }) => <TextField
                       {...input}
                       disabled={submitting}
                       autoComplete="off"
                       error={!!error}
                       helperText={!!error && i18n("Author.Login:CantResetPassword")}
                       width="auto"
                       placeholder={i18n("Login:Username")}
                     />}
                   </Field>
                 </Grid>

                 <SubmitButton label={i18n("Account.ForgottenPassword:SendEmail")}
                               type="submit" disabled={submitting || !values.username?.trim()}
                               isLoading={submitting}/>
               </StyledLoginForm>}/>
}
